module.exports = __webpack_public_path__ + "img/流体力学1_3.a1f2e0bc.jpg";